import { Component, OnInit } from '@angular/core';
import { FieldConfig } from '../dynamic-form/dynamic-form-config.interface';
import { FormGroup } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { CheckboxService } from './checkbox.service';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit {

  field: FieldConfig;
  group: FormGroup;

  constructor(private checkboxService: CheckboxService) { }

  onClick(data): void {
    this.checkboxService.onClick(data);
  }


  ngOnInit(): void {
  }
}
